import { ChangeEvent, memo, useState } from "react"
import { useLanguageTool } from "../hooks/useLanguageTool"
import { Mode, OptionGroupProps, OptionProps, ValueProps } from "../config/types"


const OptionSectionLive = ({ mode, sampleText } : { mode: Mode, sampleText: () => void}) => {

    const { optionManager } = useLanguageTool()
    const [ optionsExpanded, setOptionsExpanded ] = useState(false)
    const config = optionManager.getConfig()


    const checkHandler = () => {
        setOptionsExpanded(!optionsExpanded)
    }

    if (mode === "Paraphrase") {
        return <></>
    }

    return (
        <section className="formulari-eines" style={{ marginTop: "20px" }}>
            <div className="formulari form-horizontal">
                <div className="traductor-checkbox form-group">
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-9">
                                <div className="checkbox checkbox-corrector">
                                <label className="checkbox-inline">
                                    <input 
                                        type="checkbox" 
                                        name="mostra_opcions" 
                                        id="mostra_opcions" value="mostra_opcions" checked={optionsExpanded} onChange={checkHandler} />Més opcions<br/><br/>
                                </label>
                            </div>
                            </div>
                            <div className="col-sm-3" style={{marginTop: '15px'}} >
                                <a id="text_prova" onClick={sampleText}>
                                    <i title="Insereix un text de prova" style={{ color: "#999"}} className="fa fa-caret-square-o-up
"></i> Text de prova
                                </a>
                            </div>
                        </div>
                        { 
                            optionsExpanded && (
                                <div id="opcionscorreccio">
                                    <h4>Opcions</h4>
                                    {config.groups.map(g => <OptionGroup key={g.summary} group={g} />)}
                                </div>
                            )
                        }
                        
                    </div>
                </div>
            </div>
        </section>)
}

const OptionGroup = ({ group }: { group: OptionGroupProps }) => {

    const { optionManager } = useLanguageTool()

    if (group.variant) {
        if (group.variant !== optionManager.getVariant()) {
            return <></>
        }
    }

    const title = group.title ? <h5>{group.title}</h5> : <></>
    const maxValues = group.options.reduce((accum, curr) => {
        if (curr.type === "checkbox" || curr.hide) {
            return accum
        }
        const count = curr.values.filter(v => !v.hide).length

        return accum > count ? accum : count
    }, 0)

    return (
        <>
            {title}
            <table summary={group.summary} border={1}>
                <tbody>
                    {group.options.map(o => <Option key={o.id} option={o} maxValues={maxValues} />)}
                </tbody>
            </table>
        </>
    )
}

const Option = ({ option, maxValues } : { option: OptionProps, maxValues: number}) => {

    if (option.hide) {
        return <></>
    }

    const text = option.link ? (<a href={option.link} target="_blank">{option.title}</a>) : option.title;

    if (option.type === "checkbox") {
        return (
            <tr>
                <td>{text}</td>
                <td colSpan={maxValues}>

                    {option.values.map(v => <OptionValue type={option.type} checked={v.default} key={v.id} id={v.id} value={v} />)}
                </td>
            </tr>
        )
    }

    return (
        <tr>
            <td>{text}</td>
            {option.values.map(v => <OptionValue type={option.type} checked={v.default} key={v.id} id={option.id} value={v} />)}
        </tr>
    )
}

type OptionValueProps = {
    type: "checkbox"|"radio"
    checked?: boolean
    key: string
    id: string
    value: ValueProps
}

const OptionValue = ({ id, value, type, checked } : OptionValueProps) => {
    const { optionManager } = useLanguageTool()

    if (value.hide) {
        return <></>
    }

    const persist = (e: ChangeEvent) => {
        const el = e.target as HTMLInputElement
        optionManager.setPreference(type, id, value.id, el.checked)
    }

    const text = value.link ? (<a href={value.link} target="_blank">{value.title}</a>) : value.title;

    if (type === "radio") {
        return <td><input type="radio" name={id} id={value.id} value={value.id} onChange={persist} defaultChecked={checked} /> {text}</td>
    }

    return (
        <><input type="checkbox" name={id} id={value.id} value={value.id} onChange={persist} defaultChecked={checked} /> {text}<br /></>
    )
}

export const OptionSection = memo(OptionSectionLive)
